import { Scene } from 'three'

import { Sizes } from "./experience/utils/sizes"
import { Timer } from './experience/utils/timer'

import { Camera } from './experience/camera'
import { Graph } from './experience/graph'
import { Logo } from './experience/logo'
import { Screen } from './experience/screen'

export { Experience }

class Experience {
    #scene = new Scene()
    #sizes = new Sizes()
    #timer = new Timer()
    #camera = new Camera(this.#sizes, this.#timer)

    #graph = new Graph(this.#timer)
    #logo = new Logo(this.#timer)

    #id
    #screen

    #initEventListeners() {
        this.#sizes.addEventListener("resize", ({ x, y }) => {
            this.#screen.resize([x, y])
            this.#camera.resize({ x, y })
        })

        this.#timer.addEventListener("tick", () => {
            this.#screen.tick()
        })
    }

    #initIsActiveListener() {
        window.addEventListener("visibilitychange", () => {
            this.#screen.rolling(document.visibilityState == "visible")
        }, { passive: true })
    }

    #initScrollListener(domElement) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > document.documentElement.clientHeight / 2)
                domElement.classList.add("blur")
            else domElement.classList.remove("blur")
        }, { passive: true })
    }

    constructor(id) {
        const domElement = document.getElementById(id)
        if (!domElement) return

        this.#camera.translateZ(10)
        this.#scene.add(this.#camera)

        this.#scene.add(this.#logo, this.#graph)

        this.#screen = new Screen(domElement)
        this.#screen.project(this.#scene, this.#camera)
        this.#screen.rolling()

        this.#initEventListeners()
        this.#initIsActiveListener()
        this.#initScrollListener(domElement)
    }

    setCurrentChapter(id) {
        if (this.#id == id) return
        else this.#id = id

        this.#graph.setCurrentChapter(id)
    }
}